import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreBoolean } from '../../ParseHelper';
import { AudioStreamType } from '../../../System/Audio/AudioSystem';

type PlayerStateKey = 'settings';
type PlayerDataKeys = AudioStreamType | 'cinematicMode';
export default class Settings implements PlayerProperty<
    PlayerStateKey,
    PlayerDataKeys
> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return (
            playerEndpointData[AudioStreamType.MUSIC] !==
                Number(playerStateData.settings[AudioStreamType.MUSIC]) ||
            playerEndpointData[AudioStreamType.SFX] !==
                Number(playerStateData.settings[AudioStreamType.SFX]) ||
            playerEndpointData.cinematicMode !==
                Number(playerStateData.settings.cinematicMode)
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return {
            [AudioStreamType.MUSIC]: restoreBoolean(
                playerEndpointData[AudioStreamType.MUSIC],
                true
            ),
            [AudioStreamType.SFX]: restoreBoolean(
                playerEndpointData[AudioStreamType.SFX],
                true
            ),
            cinematicMode: restoreBoolean(
                playerEndpointData.cinematicMode,
                false
            ),
        };
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            [AudioStreamType.MUSIC]: Number(
                playerStateData.settings[AudioStreamType.MUSIC]
            ),
            [AudioStreamType.SFX]: Number(
                playerStateData.settings[AudioStreamType.SFX]
            ),
            cinematicMode: Number(playerStateData.settings.cinematicMode),
        };
    }
}
